@if (supervisorState) {
    @switch (supervisorState.subPhase) {
        @case (SupervisorSubPhase.WaitingForSupervisor) {
            <app-supervisor-panel
                [inverseColors]="true"
                [message]="'Scan supervisor card to continue'"
                (backClicked)="cancelActionClicked.emit()"
            />
        }

        @case (SupervisorSubPhase.ConfirmAction) {
            @switch (supervisorState.selectedAction) {
                @case (SupervisorAction.ContinueGame) {
                    <app-supervisor-panel
                        title="Continuing game"
                        i18n-title
                        message="Scan supervisor card to continue game"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.VoidGame) {
                    <app-supervisor-panel
                        [title]="titleVoidGame"
                        message="Scan supervisor card to confirm changes and continue"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.FreeHand) {
                    <app-supervisor-panel
                        [title]="titleFreeHand"
                        message="Scan supervisor card to confirm"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.ChangeResult) {
                    @if (supervisorState.changedGameResult) {
                        <app-supervisor-panel
                            title="Result changed"
                            i18n-title
                            message="Scan supervisor card to confirm changes and continue"
                            i18n-message
                            (backClicked)="cancelActionClicked.emit()"
                        />
                    }
                }

                @case (SupervisorAction.CloseTable) {
                    <app-supervisor-panel
                        [title]="titleCloseTable"
                        message="Scan supervisor card to confirm changes and continue"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }
            }
        }

        @case (SupervisorSubPhase.ConfirmGameSelection) {
            <app-supervisor-panel
                [title]="titleConfirmGameSelection"
                message="Scan supervisor card to confirm the selection and continue"
                i18n-message
                (backClicked)="cancelActionClicked.emit()"
            />
        }
    }
}
